<div class="row">
  <div class="col-sm-12">
    <select
      class="form-control"
      [(ngModel)]="level1"
      (change)="changeSelect()"
      aria-label="Default select example"
    >
      <option [ngValue]="null">
        {{ 'Elija alguna categoría' | uppercase }}
      </option>
      <option *ngFor="let item of categorias" value="{{ item.slug }}">
        {{ item.name }}
      </option>
    </select>
  </div>
</div>
<div class="row" style="margin-top: 20px" *ngIf="categoria2.length">
  <div class="col-sm-6">
    <select
      class="form-control"
      [(ngModel)]="level2"
      (change)="changeSelect2()"
      aria-label="Default select example"
    >
      <option [ngValue]="null">Escoja alguna Subcategoria</option>
      <option *ngFor="let item of categoria2" value="{{ item.slug }}">
        {{ item.name }}
      </option>
    </select>
  </div>
  <div class="col-sm-6">
    <select
      class="form-control"
      [(ngModel)]="level3"
      aria-label="Default select example"
    >
      <option [ngValue]="null">Escoja alguna Subcategoria</option>
      <option *ngFor="let item of categoria3" value="{{ item.slug }}">
        {{ item.name }}
      </option>
    </select>
  </div>
</div>
<hr />
<div class="row">
  <div class="col-sm-12">
    <div class="flex align-items-center">
      <button type="button" (click)="Filtrar()" class="btn btn-outline-dark">
        <i class="fas fa-filter" style="margin-right: 10px"></i> filtrar
      </button>
    </div>
  </div>
</div>
